<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <h4>Editar apelido bloqueado</h4>

  <!-- EDITAR-->
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <!-- NOME -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="exampleInputEmail1">Nome</label>
            <input @keyup="formatar" class="form-control" id="nome" placeholder="Nome" v-model="formData.name" />

            <span style="color: red" v-for="error in v$.name.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer" style="width: 100%">
      <button type="submit" class="btn btn-primary" @click="update()">Salvar</button>
      <a id="close_editar" data-dismiss="modal" @click="close" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["blockname", "closeModal", "acaoRealizada"],

  components: { Loading },

  data() {
    return {
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      name: "",
    });

    const rules = computed(() => {
      return {
        name: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.formData.name = this.blockname.name;

    console.log("Editar criado");
    console.log(this.blockname);
  },

  methods: {
    formatar() {
      this.formData.name = this.formData.name.toUpperCase();
    },

    close() {
      let btn = document.getElementById("close_editar");
      btn.click();

      this.closeModal();
    },

    async update() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          id: this.blockname.id,
          name: this.formData.name,
        };

        console.log("Atualizando");
        console.log(data);

        axios
          .post(`/admin/blockname/update`, data)
          .then((response) => {
            this.isLoading = false;

            let btn = document.getElementById("close_editar");
            btn.click();

            this.showSuccessMessageWithButton("Sucesso", "Apelido bloqueado editado");
            this.acaoRealizada("editar");
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },
  },
};
</script>
